"use strict";

exports.__esModule = true;
exports.default = void 0;
var _emotion = require("emotion");
var _react = _interopRequireDefault(require("react"));
var _fa = require("react-icons/fa");
var _propTypes = require("prop-types");
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
var _Flex = _interopRequireDefault(require("../../layouts/Flex"));
var _typography = require("../../atoms/typography");
var _Overlay = _interopRequireDefault(require("../../atoms/Overlay"));
var _LazyImage = _interopRequireDefault(require("../../atoms/LazyImage/LazyImage"));
var _css, _css2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var main = /*#__PURE__*/
(0, _emotion.css)("border-radius:1px;background-color:#ffffff;box-shadow:0 2px 4px 0 rgba(0,0,0,0.05);padding:4px;");
var image = /*#__PURE__*/
(0, _emotion.css)("width:100%;");
var titleCls = /*#__PURE__*/
(0, _emotion.css)((_css = {
  color: '#545761',
  fontWeight: 'bold',
  lineHeight: '24px',
  fontSize: '1.2rem'
}, _css[(0, _mediaQueries.default)('md')] = {
  fontSize: '1.125rem'
}, _css));
var descriptionCls = /*#__PURE__*/
(0, _emotion.css)((_css2 = {
  fontSize: '1.025rem',
  maxWidth: 300,
  margin: '10px auto 0 auto'
}, _css2[(0, _mediaQueries.default)('md')] = {
  fontSize: '0.875rem'
}, _css2.color = '#545761', _css2.lineHeight = '19px', _css2));
var linkCls = /*#__PURE__*/
(0, _emotion.css)("color:#7136d5;font-size:14px;font-weight:600;line-height:19px;text-align:center;");
var Title = function Title(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, ["children"]);
  return _react.default.createElement(_typography.H3, _extends({
    className: (0, _emotion.css)(titleCls)
  }, props), children);
};
var Description = function Description(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, ["children"]);
  return _react.default.createElement("p", _extends({
    className: (0, _emotion.css)(descriptionCls)
  }, props), children);
};
var Actions = function Actions(_ref3) {
  var likes = _ref3.likes,
    href = _ref3.href,
    linkText = _ref3.linkText,
    handleIconClick = _ref3.handleIconClick,
    iconStyle = _ref3.iconStyle,
    props = _objectWithoutProperties(_ref3, ["likes", "href", "linkText", "handleIconClick", "iconStyle"]);
  return _react.default.createElement(_Flex.default, _extends({
    className: (0, _emotion.css)( /*#__PURE__*/
    (0, _emotion.css)({
      justifyContent: 'space-between',
      padding: '15px 16px 15px 16px'
    }))
  }, props), _react.default.createElement("p", {
    className: (0, _emotion.css)( /*#__PURE__*/
    (0, _emotion.css)({
      margin: 0
    }))
  }, href && _react.default.createElement("a", {
    className: (0, _emotion.css)(linkCls),
    href: href
  }, linkText)), likes && _react.default.createElement(_Flex.default, null, _react.default.createElement("span", {
    className: (0, _emotion.css)( /*#__PURE__*/
    (0, _emotion.css)({
      opacity: 0.45,
      color: '#545761',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '19px'
    }))
  }, likes), ' ', _react.default.createElement("span", null, _react.default.createElement(_fa.FaHeart, {
    onClick: handleIconClick || function () {
      return null;
    },
    style: _extends({
      color: '#B2B4B8',
      marginLeft: 5,
      cursor: handleIconClick ? 'pointer' : undefined
    }, iconStyle),
    size: 15
  }))));
};
Actions.displayName = 'Actions';
var OverlayContent = function OverlayContent(_ref4) {
  var children = _ref4.children;
  return _react.default.createElement("div", {
    className: /*#__PURE__*/
    (0, _emotion.css)("padding:15px 16px 15px 16px")
  }, children);
};
OverlayContent.displayName = 'OverlayContent';
var HoverCard = /*#__PURE__*/
function (_React$Component) {
  function HoverCard() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = HoverCard.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      cover = _this$props.cover,
      children = _this$props.children,
      showImagePlaceholder = _this$props.showImagePlaceholder,
      props = _objectWithoutProperties(_this$props, ["cover", "children", "showImagePlaceholder"]);
    var filteredChilds = children && children.filter(function (e) {
      return e.type.displayName !== 'Actions' && e.type.displayName !== 'OverlayContent';
    });
    var actionChild = children && children.find(function (e) {
      return e.type.displayName === 'Actions';
    });
    var overlayChild = children && children.find(function (e) {
      return e.type.displayName === 'OverlayContent';
    });
    return _react.default.createElement("div", _extends({
      className: (0, _emotion.css)(main)
    }, props), _react.default.createElement(_Overlay.default, {
      content: overlayChild
    }, showImagePlaceholder ? _react.default.createElement(_LazyImage.default, {
      style: {
        width: '100%'
      },
      alt: "product",
      src: cover
    }) : _react.default.createElement("img", {
      className: (0, _emotion.css)(image),
      alt: "product",
      src: cover
    }), _react.default.createElement("div", {
      className: /*#__PURE__*/
      (0, _emotion.css)("padding:15px 16px 15px 16px")
    }, filteredChilds)), actionChild);
  };
  _inheritsLoose(HoverCard, _React$Component);
  return HoverCard;
}(_react.default.Component);
_defineProperty(HoverCard, "Title", Title);
_defineProperty(HoverCard, "Description", Description);
_defineProperty(HoverCard, "Actions", Actions);
_defineProperty(HoverCard, "Overlay", OverlayContent);
Actions.defaultProps = {
  linkText: 'VIEW MORE'
};
Actions.propTypes = {
  likes: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  href: _propTypes.string,
  handleIconClick: _propTypes.func,
  linkText: _propTypes.string,
  iconStyle: _propTypes.object
};
HoverCard.propTypes = {
  cover: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  showImagePlaceholder: _propTypes.bool
};
Title.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
Description.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
OverlayContent.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
var _default = HoverCard;
exports.default = _default;